import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

/* SQUIDDI-seo - 2026-10-17
   Tag <head> per pagina. I valori predefiniti sono GLI STESSI di
   public/index.html: se una pagina non passa un dato, resta quello del sito.
   I tag statici in index.html hanno `data-rh="true"`, così react-helmet-async
   li SOSTITUISCE invece di aggiungerne di nuovi (niente doppioni).
   Regole: titolo ≤ 60 caratteri, descrizione ≤ 155, URL sempre assoluti su
   https://squiddi.com, og:image = foto reale del prodotto. */

export const SITE = "https://squiddi.com";

const DEF_TITLE = "Squiddi — Abbigliamento personalizzato & divise su misura";
const DEF_OG_TITLE = "Squiddi — Abbigliamento personalizzato e divise su misura";
const DEF_DESC = "Squiddi — abbigliamento personalizzato, divise e capi su misura. Stampa, ricamo e patch su t-shirt, felpe, polo e divise da lavoro, con anteprima gratuita.";
const DEF_OG_DESC = "Stampa, ricamo e patch su t-shirt, felpe, polo e divise. Personalizzi online in pochi minuti oppure un designer ti prepara l'anteprima gratis.";
const DEF_IMAGE = `${SITE}/assets/og/squiddi-social.jpg`;

/* Taglia sull'ultima parola intera, senza spezzare a metà. */
const clamp = (value, max) => {
  const t = String(value || "").replace(/\s+/g, " ").trim();
  if (t.length <= max) return t;
  const cut = t.slice(0, max - 1);
  const space = cut.lastIndexOf(" ");
  return `${(space > max * 0.6 ? cut.slice(0, space) : cut).trim()}…`;
};

/* Indirizzo assoluto sul dominio di produzione (vale anche per le foto). */
export const absUrl = (p) => {
  const s = String(p || "").trim();
  if (!s) return "";
  if (/^https?:\/\//i.test(s)) return s;
  return `${SITE}${s.startsWith("/") ? "" : "/"}${s}`;
};

/* Nomi a catalogo tutti maiuscoli → leggibili nel titolo («T-SHIRT GIROCOLLO»
   diventa «T-shirt girocollo»). Se il nome ha già minuscole resta com'è. */
export const prettyName = (name) => {
  const s = String(name || "").trim();
  if (!s || /[a-zà-ú]/.test(s)) return s;
  return s.charAt(0) + s.slice(1).toLowerCase();
};

export default function Seo({ title, description, path, image, type = "website", noindex = false }) {
  const { pathname } = useLocation();
  const t = clamp(title || DEF_TITLE, 60);
  const ogT = title ? t : DEF_OG_TITLE;
  const d = clamp(description || DEF_DESC, 155);
  const ogD = description ? d : DEF_OG_DESC;
  const url = absUrl(path || pathname || "/");
  const img = absUrl(image) || DEF_IMAGE;

  /* `defer={false}`: i tag vengono scritti subito, non al prossimo frame. */
  return (
    <Helmet defer={false}>
      <title>{t}</title>
      <meta name="description" content={d} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Squiddi" />
      <meta property="og:locale" content="it_IT" />
      <meta property="og:title" content={ogT} />
      <meta property="og:description" content={ogD} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogT} />
      <meta name="twitter:description" content={ogD} />
      <meta name="twitter:image" content={img} />
      {noindex ? <meta name="robots" content="noindex,follow" /> : null}
    </Helmet>
  );
}
